/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, PropsWithChildren } from 'react';

import { IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

export const eikaForsikringPhonenumber = '915 03 850';
export const phone = (nr: string) => <Link href={`tel:+47${nr.replace(/\s/g, '')}`}>&nbsp; (+47) &nbsp; {nr}</Link>;
export const link = (href: string) => <Link {...{ href }}>{href}</Link>;

export const LinkButton: FC<PropsWithChildren<{ external?: boolean; href?: string }>> = ({
    href,
    children,
    external,
}) => (
    <p className="navigation--container">
        <Link
            {...{
                href,
                linkType: LinkType.BUTTON_STANDARD_POSITIVE,
                ...(external && {
                    target: '_blank',
                    icon: IconTypes.EKSTERN_24,
                }),
            }}
        >
            {children}
        </Link>
    </p>
);
